import Vue from "vue";

export const mutations = {
  SET_USER(state, userData) {
    state.userData = userData;
    state.effectiveUserData = userData;
  },
  SET_ROLES(state, userRoles) {
    Vue.set(state, "roles", userRoles);
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  LOGOUT_USER(state) {
    state.userData = null;
  },
};
